import {AlertTriangleIcon, CheckIcon, XIcon} from 'lucide-react';

export type StatusBoxProps = {
  title: string;
  text: string;
  status?: 'success' | 'failed';
};

export function StatusBox({status, title, text}: StatusBoxProps) {
  if (status === 'success') {
    return (
      <div className="flex items-center gap-3 rounded-lg border border-green-100 bg-green-50 p-4">
        <div className="rounded-full bg-green-100 p-1">
          <CheckIcon className="h-5 w-5 text-green-600" />
        </div>
        <div>
          <p className="font-semibold text-green-800">{title}</p>
          <p className="text-sm text-green-700">{text}</p>
        </div>
      </div>
    );
  }

  if (status === 'failed') {
    return (
      <div className="flex items-center gap-3 rounded-lg border border-red-100 bg-red-50 p-4">
        <div className="rounded-full bg-red-100 p-1">
          <XIcon className="h-5 w-5 text-red-600" />
        </div>
        <div>
          <p className="font-semibold text-red-800">{title}</p>
          <p className="text-sm text-red-700">{text}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 rounded-lg border border-amber-100 bg-amber-50 p-4">
      <div className="rounded-full bg-amber-100 p-1">
        <AlertTriangleIcon className="h-5 w-5 text-amber-600" />
      </div>
      <div>
        <p className="font-semibold text-amber-800">{title}</p>
        <p className="text-sm text-amber-700">{text}</p>
      </div>
    </div>
  );
}
